import { RootState } from '@checkout/state';
import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { RootAction } from '../actions/actionTypes.d';

interface IExtendedMiddleware<StateType> extends Middleware {
  <S extends StateType, D extends Dispatch = Dispatch>(api: MiddlewareAPI<D, S>): (next: Dispatch<AnyAction>) => (action: any) => any;
}

const eventsMiddleWare: IExtendedMiddleware<RootState> =
  <S extends RootState, D extends Dispatch = Dispatch>(api: MiddlewareAPI<D, S>) => (next: Dispatch<AnyAction>) =>
    <A extends RootAction>(action: any) => {
      // tslint:disable-next-line:no-console
      // console.log('outsideEventsMiddleWare triggered action:', action);
      // tslint:disable-next-line:no-console
      // console.log('Current checkout store:', api.getState());
      if (window.dispatchEvent) {
        const { type, payload } = action;

        window.dispatchEvent(new CustomEvent(type, {
          detail: {
            action: {
              completed: true,
              type: type,
              payload: payload // Payload that has been provided to the action creator function
            },
            state: api.getState() // State before action creator update the store
          }
        }));
      }
      return next(action);
    };

export default eventsMiddleWare;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/eventsMiddleWare.ts